import {
  Input,
  Component,
  ViewChild,
  SimpleChanges,
  AfterViewInit, OnChanges,
  OnInit,
} from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxDropDownButtonComponent } from 'jqwidgets-ng/jqxdropdownbutton';

import { ElementoModel } from 'src/app/services/elements/models/elem.model';
import { ElemInstalacionDetalleModel } from 'src/app/services/elements/models/instalacion/elem-instalacion-detalle.model';

import { ElementsEditComponent } from '../elements-edit.component';
import { ElemInstalacionNuevaInstalacion } from 'src/app/services/elements/models/instalacion/elem-instalacion-nueva-instalacion.model';
import { jqxCheckBoxComponent } from 'jqwidgets-ng/jqxcheckbox';
import { InstallationTypes } from 'src/app/services/elements/instalacion/instalacion.service';
import { ElementsService } from 'src/app/services/elements/elements.service';
import { HistorialInstalacionesModel } from 'src/app/interfaces/historial-instalaciones.model';
import { Grid } from 'projects/movisat-common-gui/src/lib/models/grid.model';
import { UserLangService } from 'src/app/services/common/user-lang/user-lang.service';
import { GridComponent } from 'movisat-common-gui';

@Component({
  selector: 'app-elements-edit-instalaciones',
  templateUrl: './elements-edit-instalaciones.component.html',
  styleUrls: ['./elements-edit-instalaciones.component.css', '../elements-edit.component.css']
})
export class ElementsEditInstalacionesComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() public elemEdit: ElementoModel;

  @ViewChild('checkCerraduraGeneral') public checkCerraduraGeneral: jqxCheckBoxComponent;
  @ViewChild('checkCerraduraEcolock') public checkCerraduraEcolock: jqxCheckBoxComponent;
  @ViewChild('dropIdentificacionEcolock') public dropIdentificacionEcolock: jqxDropDownListComponent;
  @ViewChild('dropEstadoInstalacionEcolock') public dropEstadoInstalacionEcolock: jqxDropDownListComponent;
  @ViewChild('dropEstadoInstalacionIdentificaciones') public dropEstadoInstalacionIdentificaciones: jqxDropDownListComponent;
  @ViewChild('dropTipoDispositivoEcolock') public dropTipoDispositivoEcolock: jqxDropDownListComponent;
  @ViewChild('gridIncidenciasEcolock') public gridIncidenciasEcolock: jqxGridComponent;
  @ViewChild('dropEstadoInstalacionGeneral') public dropEstadoInstalacionGeneral: jqxDropDownButtonComponent;
  @ViewChild('dropEstadoInstalacionVolum') public dropEstadoInstalacionVolum: jqxDropDownListComponent;
  @ViewChild('gridIncidenciasVolum') public gridIncidenciasVolum: jqxGridComponent;
  @ViewChild('dropEstadoInstalacionTag') public dropEstadoInstalacionTag: jqxDropDownListComponent;
  @ViewChild('gridIncidenciasTag') public gridIncidenciasTag: jqxGridComponent;
  @ViewChild('gridHistorial') public gridHistorial: GridComponent;

  public incdVolumSelec: any;
  public columnsIncidenciasTag;
  public sourceIncidenciasTag;
  public dataAdapterIncidenciasTag;
  public incdEcolockSelec: any;

  public sourceEstadoInstalacion =
    [
      { label: AppComponent.translate('Pendiente_instalacion'), value: 4 },
      { label: AppComponent.translate('Sin_lectura'), value: 5 },
      { label: AppComponent.translate('Instalado_correctamente'), value: 6 },
      { label: AppComponent.translate('Instalado_sin_cobertura'), value: 29 },
    ];
  public sourceEstadoInstalacionGeneral =
    [
      { label: AppComponent.translate('Pendiente_instalacion'), value: 1 },
      { label: AppComponent.translate('En_progreso'), value: 2 },
      { label: AppComponent.translate('Instalado_correctamente'), value: 3 },
    ];
  public columnsIncidenciasVolum;
  public sourceIncidenciasVolum;
  public dataAdapterIncidenciasVolum;

  public incdTagSelec: any;
  public sourceTipoDispositivoEcolock = [];
  public sourceIdentificacionEcolock =
    [
      { label: AppComponent.translate('Tarjeta_nfc'), value: 0 },
      { label: 'Bluetooth', value: 1 },
    ];
  public columnsIncidenciasEcolock;
  public sourceIncidenciasEcolock;
  public dataAdapterIncidenciasEcolock;

  public environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  public editTag: boolean = true;
  public editVolumetrico: boolean = true;
  public editEcoLock: boolean = true;
  public editIdentificaciones: boolean = true;

  public static _this: ElementsEditInstalacionesComponent;

  protected historialInstalaciones: any[] = [];
  protected columnsHistorial;
  protected sourceHistorial;
  protected dataAdapterHistorial;

  protected gridConfig: Grid

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public constructor(
    private elementsService: ElementsService,
    private userLangService: UserLangService,
  ) {
    ElementsEditInstalacionesComponent._this = this

  }

  public ngOnInit(): void {
    this.langGrid = JqWidgets.getLocalization(this.userLangService.getUserLangShort());
    this.gridConfig = {
      localization: this.langGrid,
      isGroupable: true,
    }

    this.elementsService.getHistorialElementos().subscribe((elements: HistorialInstalacionesModel[]) => {
      elements.forEach((elemento: HistorialInstalacionesModel) => {
        if (elemento.idElemento == this.elemEdit.Id) {
          this.historialInstalaciones.push(elemento);
        }
      });
      this.initHistorialGrid();
    });
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.dropEstadoInstalacionTag) {
        if (this.getDetalleInstalacion(1)) {
          const detalle = this.getDetalleInstalacion(1)
          switch (detalle.idEstado) {
            case 4:
              this.dropEstadoInstalacionTag.selectIndex(0);
              break;
            case 5:
              this.dropEstadoInstalacionTag.selectIndex(1);
              break;
            case 29:
              this.dropEstadoInstalacionTag.selectIndex(2);
              break;
            case 6:
              this.dropEstadoInstalacionTag.selectIndex(3);
          }
        }
      }

      if (this.dropEstadoInstalacionVolum) {
        if (this.getDetalleInstalacion(2)) {
          switch (this.getDetalleInstalacion(2).idEstado) {
            case 4:
              this.dropEstadoInstalacionVolum.selectIndex(0);
              break;
            case 5:
              this.dropEstadoInstalacionVolum.selectIndex(1);
              break;
            case 29:
              this.dropEstadoInstalacionVolum.selectIndex(2);
              break;
            case 6:
              this.dropEstadoInstalacionVolum.selectIndex(3);
          }
        }
      }

      if (this.dropEstadoInstalacionEcolock) {
        if (this.getDetalleInstalacion(3)) {
          switch (this.getDetalleInstalacion(3).idEstado) {
            case 4:
              this.dropEstadoInstalacionEcolock.selectIndex(0);
              break;
            case 5:
              this.dropEstadoInstalacionEcolock.selectIndex(1);
              break;
            case 29:
              this.dropEstadoInstalacionEcolock.selectIndex(2);
              break;
            case 6:
              this.dropEstadoInstalacionEcolock.selectIndex(3);
          }
        }
      }

      if (this.dropEstadoInstalacionIdentificaciones) {
        if (this.getDetalleInstalacion(4)) {
          switch (this.getDetalleInstalacion(4).idEstado) {
            case 4:
              this.dropEstadoInstalacionIdentificaciones.selectIndex(0);
              break;
            case 5:
              this.dropEstadoInstalacionIdentificaciones.selectIndex(1);
              break;
            case 29:
              this.dropEstadoInstalacionIdentificaciones.selectIndex(2);
              break;
            case 6:
              this.dropEstadoInstalacionIdentificaciones.selectIndex(3);
          }
        }
      }
    }, 500)
  }

  private getUltimoDetallePorInstalacionYTipo(idInstalacion: number, idTipo: number): ElemInstalacionDetalleModel | null {
    if (!this.elemEdit?.Instalacion?.detalle?.length) return null;

    return this.elemEdit.Instalacion.detalle
      .filter(d => d.idInstalacion === idInstalacion && d.idTipo === idTipo)
      .sort((a, b) => b.id - a.id)[0] || null;
  }


  public ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'elemEdit': {
            this.elemEdit = changes[propName].currentValue;

            if (this.elemEdit?.Id > 0 && this.elemEdit.Instalacion?.detalle) {
              const combDet = { ...this.elemEdit.Instalacion.detalle.find(det => det.idTipo === 3) };

              combDet.id = 0;
              combDet.idTipo = 5;
              combDet.imagenes = [];
              combDet.notificaciones = [];

              const detTipo4 = this.elemEdit.Instalacion.detalle.find(det => det.idTipo === 4);
              if (detTipo4) {
                combDet.imagenes.push(...(detTipo4.imagenes || []));
                combDet.notificaciones.push(...(detTipo4.notificaciones || []));
              }

              this.elemEdit.Instalacion.detalle.push(combDet);
            }

            const detalle = this.getUltimoDetallePorInstalacionYTipo(
              this.elemEdit?.Instalacion?.id,
              InstallationTypes.LOCK
            );

            if (detalle && this.elemEdit?.Instalacion?.detalle) {
              this.elemEdit.Instalacion.detalle.push(detalle);
            }

            this.initGridIncidenciasTag();
            this.initGridIncidenciasVolum();
            this.initGridIncidenciasEcolock();
            break;
          }
          default:
            break;
        }
      }
    }
  }

  public checkRequire(event: any, idTipo: number): void {
    /* Se instancia la nuevaInstalacion con el tipo que corresponde y la accion de instalacion(1) */
    const newInstalacion: ElemInstalacionNuevaInstalacion = new ElemInstalacionNuevaInstalacion();
    newInstalacion.idAccion = 1;
    newInstalacion.idTipo = idTipo;

    const detalleInstalacion: ElemInstalacionDetalleModel = new ElemInstalacionDetalleModel();
    detalleInstalacion.idAccion = 1;
    detalleInstalacion.idTipo = idTipo;

    switch (idTipo) {
      case 1:
        this.elemEdit.Instalacion.requiereInstalacionTag = event.args.checked;
        break;
      case 2:
        this.elemEdit.Instalacion.requiereInstalacionVolumetrico = event.args.checked;
        break;
      case 3:
        this.elemEdit.Instalacion.requiereInstalacionCerradura = event.args.checked;
        break;
      case 4:
        this.elemEdit.Instalacion.requiereInstalacionIdentificador = event.args.checked;

        if (!this.elemEdit.Instalacion.requiereInstalacionIdentificador && this.elemEdit.Instalacion.requiereInstalacionCerradura) {
          this.checkCerraduraGeneral.uncheck();
        }
        break;
    }

    if (this.elemEdit.Instalacion.instalaciones) {
      const index = this.elemEdit.Instalacion.instalaciones.findIndex(newInstal => newInstal.idTipo === idTipo);

      if (index !== -1) {
        this.elemEdit.Instalacion.instalaciones.splice(index, 1);
        this.elemEdit.Instalacion.detalle.splice(index, 1);
      } else {
        this.elemEdit.Instalacion.instalaciones.push(newInstalacion);
        this.elemEdit.Instalacion.detalle.push(detalleInstalacion);
      }
    }
  }

  public selectEstadoDetalleInstalacion(event: any, idTipo: number): void {
    const detalleInstalacion = this.getDetalleInstalacion(idTipo);
    if (detalleInstalacion) {
      detalleInstalacion.idEstado = event.args.item.value;
    } else {
      console.debug('Detalle de instalación no encontrado');
    }
  }

  public getDetalleInstalacion(tipo: number): ElemInstalacionDetalleModel {
    if (this.elemEdit && this.elemEdit.Instalacion && this.elemEdit.Instalacion.detalle) {
      let detalleInstalacion = this.elemEdit.Instalacion.detalle.find(det => det.idTipo === tipo);
      if (detalleInstalacion) {
        return detalleInstalacion;
      } else {
        // Create and return a new instance if not found
        detalleInstalacion = new ElemInstalacionDetalleModel();
        detalleInstalacion.idTipo = tipo;
        this.elemEdit.Instalacion.detalle.push(detalleInstalacion);
        return detalleInstalacion;
      }
    }
    // Return undefined if `detalle` does not exist
    return undefined;
  }

  public addImageDetalle(event: any, tipo: number): void {
    this.getDetalleInstalacion(tipo).imagenes.push(event);
  }

  public rmvImageDetalle(event: any, tipo: number): void {
    this.getDetalleInstalacion(tipo).imagenes.splice(this.getDetalleInstalacion(tipo).imagenes.indexOf(event), 1);
    ElementsEditComponent._this.form.collapseWindow();
    setTimeout(() => {
      ElementsEditComponent._this.form.expandWindow();
    }, 250)
  }

  public addImageNotificacion(event: any, selectNotif: any): void {
    selectNotif.Imagenes.push(event);
  }

  public rmvImageNotificacion(event: any, selectNotif: any): void {
    selectNotif.Imagenes.splice(selectNotif.Imagenes.indexOf(event), 1);
    ElementsEditComponent._this.form.collapseWindow();
    setTimeout(() => {
      ElementsEditComponent._this.form.expandWindow();
    }, 300)
  }

  public async initBtnColumn(
    row: any,
    column: any,
    value: string,
    htmlElement: HTMLElement,
    from: number
  ): Promise<void> {
    let rowdata: any = row.bounddata;
    htmlElement.innerHTML = '';

    const btnSeeImgs = document.createElement('button');
    btnSeeImgs.type = 'button';
    btnSeeImgs.id = 'buttonEdit_Button';
    btnSeeImgs.title = AppComponent.translate('Ver_imagenes');
    btnSeeImgs.innerHTML = '<i class="fa-solid fa-eye"></i>';
    btnSeeImgs.style.margin = '0 5px';

    if (rowdata && !rowdata.informacionGrafica?.length) {
      btnSeeImgs.setAttribute('disabled', 'true');
      btnSeeImgs.classList.add('disabled');
      btnSeeImgs.title = '';
    } else {
      btnSeeImgs.addEventListener('click', (event: any) => {
        switch (from) {
          case 1: // Tag
            if (isNaN(row)) {
              rowdata = row.bounddata;
            } else {
              rowdata = this.gridIncidenciasTag.getrowdata(row);
            }

            this.incdTagSelec = null;

            this.incdTagSelec = this.getDetalleInstalacion(1).notificaciones[this.getDetalleInstalacion(1).notificaciones.findIndex(not => not.id === rowdata.id)];
            break;
          case 2: // Volumetrico
            if (isNaN(row)) {
              rowdata = row.bounddata;
            } else {
              rowdata = this.gridIncidenciasVolum.getrowdata(row);
            }

            this.incdVolumSelec = null;

            this.incdVolumSelec = this.getDetalleInstalacion(2).notificaciones[this.getDetalleInstalacion(2).notificaciones.findIndex(not => not.id === rowdata.id)];
            break;
          case 3: // Ecolock
            if (isNaN(row)) {
              rowdata = row.bounddata;
            } else {
              rowdata = this.gridIncidenciasEcolock.getrowdata(row);
            }

            this.incdEcolockSelec = null;

            const detalle = this.getDetalleInstalacion(3);
            this.incdEcolockSelec = detalle.notificaciones.find(not => not.id === rowdata.id);
            break;
          default:
            break;
        }
      });
    }

    htmlElement.appendChild(btnSeeImgs);
  }

  public initGridIncidenciasVolum(): void {
    this.columnsIncidenciasVolum =
      [
        { text: 'ID', datafield: 'id', hidden: true },
        { text: this.translate('Fecha'), datafield: 'fecha', width: 100 },
        { text: this.translate('Descripcion'), datafield: 'descripcion', width: 150 },
        {
          text: this.translate('Informacion_grafica'), datafield: 'informacionGrafica', width: 150,
          createwidget: (
            row: any,
            column: any,
            value: string,
            htmlElement: HTMLElement
          ): void => {
            this.initBtnColumn(row, column, value, htmlElement, 2);
          },
          initwidget: (
            row: any,
            column: any,
            value: string,
            htmlElement: HTMLElement
          ): void => {
            this.initBtnColumn(row, column, value, htmlElement, 2);
          }
        },
      ];

    this.sourceIncidenciasVolum = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'number', map: 'Id' },
        { name: 'fecha', type: 'date', map: 'Fecha' },
        { name: 'descripcion', type: 'string', map: 'Texto' },
        { name: 'informacionGrafica', map: 'Imagenes' },
      ],
      localdata: this.getDetalleInstalacion(2)?.notificaciones?.length > 0 ? this.getDetalleInstalacion(2).notificaciones : []
    };

    this.dataAdapterIncidenciasVolum = new jqx.dataAdapter(this.sourceIncidenciasVolum);
  }

  public initGridIncidenciasTag(): void {
    this.columnsIncidenciasTag =
      [
        { text: 'ID', datafield: 'id', hidden: true },
        { text: this.translate('Fecha'), datafield: 'fecha', width: 100 },
        { text: this.translate('Descripcion'), datafield: 'descripcion', width: 150 },
        {
          text: this.translate('Informacion_grafica'), datafield: 'informacionGrafica', width: 150,
          createwidget: (
            row: any,
            column: any,
            value: string,
            htmlElement: HTMLElement
          ): void => {
            this.initBtnColumn(row, column, value, htmlElement, 1);
          },
          initwidget: (
            row: any,
            column: any,
            value: string,
            htmlElement: HTMLElement
          ): void => {
            this.initBtnColumn(row, column, value, htmlElement, 1);
          }
        },
      ];

    this.sourceIncidenciasTag = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'number', map: 'Id' },
        { name: 'fecha', type: 'date', map: 'Fecha' },
        { name: 'descripcion', type: 'string', map: 'Texto' },
        { name: 'informacionGrafica', map: 'Imagenes' },
      ],
      localdata: this.getDetalleInstalacion(1)?.notificaciones?.length > 0 ? this.getDetalleInstalacion(1).notificaciones : []
    };

    this.dataAdapterIncidenciasTag = new jqx.dataAdapter(this.sourceIncidenciasTag);
  }

  public initGridIncidenciasEcolock(): void {
    this.columnsIncidenciasEcolock =
      [
        { text: 'ID', datafield: 'id', hidden: true },
        { text: this.translate('Fecha'), datafield: 'fecha', width: 100, cellsformat: 'dd/MM/yyyy' },
        { text: this.translate('Hora'), datafield: 'hora', width: 100, cellsformat: 'HH:mm:ss' },
        { text: this.translate('Descripcion'), datafield: 'descripcion', width: 150 },
        {
          text: this.translate('Informacion_grafica'), datafield: 'informacionGrafica', width: 150,
          createwidget: (
            row: any,
            column: any,
            value: string,
            htmlElement: HTMLElement
          ): void => {
            this.initBtnColumn(row, column, value, htmlElement, 3);
          },
          initwidget: (
            row: any,
            column: any,
            value: string,
            htmlElement: HTMLElement
          ): void => {
            this.initBtnColumn(row, column, value, htmlElement, 3);
          }
        },
      ];

    this.sourceIncidenciasEcolock = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'number', map: 'id' },
        { name: 'fecha', type: 'date', map: 'fecha' },
        { name: 'hora', type: 'date', map: 'fecha' },
        { name: 'descripcion', type: 'string', map: 'texto' },
        { name: 'informacionGrafica', map: 'imagenes' },
      ],
      localdata: this.getDetalleInstalacion(3)?.notificaciones?.length > 0 ? this.getDetalleInstalacion(3).notificaciones : []
    };
    this.dataAdapterIncidenciasEcolock = new jqx.dataAdapter(this.sourceIncidenciasEcolock);
  }

  public initHistorialGrid(): void {
    this.columnsHistorial =
    [
      { text: 'ID', datafield: 'id', hidden: true },
      { text: this.translate('Tipo'), datafield: 'tipo', width: 150 },
      { text: this.translate('Estado_instalacion'), datafield: 'estado_instalacion', width: 150 },
      { text: this.translate('Fecha_operacion'), datafield: 'fecha_operacion', width: 100, cellsformat: 'dd/MM/yyyy HH:mm:ss' },
      { text: this.translate('Incidencias'), columntype: 'checkbox', datafield: 'incidencias', width: 150 },
    ];

    this.sourceHistorial = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'number', map: 'id' },
        { name: 'tipo', type: 'string', map: 'nombreTipo' },
        { name: 'estado_instalacion', type: 'string', map: 'estadoInstalacion' },
        { name: 'fecha_operacion', type: 'date', map: 'fechaOperacion' },
        { name: 'incidencias', type: 'checkbox', map: 'incidencias' },
      ],
      localdata: this.historialInstalaciones
    };
    this.dataAdapterHistorial = new jqx.dataAdapter(this.sourceHistorial);
  }
}
